var BaseView = require('./abstract/base');
var DesignFacade = require('../../../../facade/design/design');

module.exports = BaseView.extend({
  template: require('./templates/sticker.hbs'),

  events: {
    'touchstart .item > .type': 'toggleType',
    'mousedown .item > .type': 'toggleType',
    'click .licence .close': 'toggleType',

    'mousedown .item': 'mouseDown',
    'mousedown .item': 'mouseDown'
  },

  toggleType: function (event) {
    event.stopPropagation();
    this.$el.toggleClass('details');
    this.$el.css('height', '');
    this.trigger('resize', this.$el[0]);
  },

  addElement: function (elementData, clickedElement) {
    if ($(clickedElement).is('.replace-icon')) {
      this.replaceElement();
      return;
    }
    DesignFacade.create('sticker', _.extend(this.item, elementData));
  },

  initialize: function (options) {
    var tool = INKIVE.Tool.getInstance();

    this.item = options.item;
    this.editor = tool.editor;
    this.canvas = this.editor.canvas;

    BaseView.prototype.initialize.call(this);
    this.setImageListeners();
  },

  render: function () {
    this.$el.html(this.template(this.item));
    this.$draggable = this.$el.find('.draggable');
  },

  setImageListeners: function () {
    var image = new Image();
    var $item = this.$el;

    image.src = this.item['thumb_src'];
    image.onload = _.bind(function () {
      var imageRatio = image.width / image.height;

      $item.height(this.width / imageRatio);
      $item.find('img').attr('src', image.src);
      this.trigger('loaded');
    }, this);

    image.onerror = _.bind(this.remove, this);
  },
  replaceElement: function () {
    var selectedElements = this.canvas.getSelectedElems();
    var $selectedElement = selectedElements.length === 1 ? $(selectedElements[0]) : null;

    if ($selectedElement && $selectedElement.is('.sticker, .icon, .logo') && $selectedElement.is('.element')) {
      var bbox = $selectedElement[0].getBBox();
      var size = Math.max(bbox.width, bbox.height);

      var bboxData = {
        size: {
          width: size,
          height: size
        },
        position: {
          x: bbox.x,
          y: bbox.y
        },
        selected: true
      };

      DesignFacade.handle($selectedElement.attr('id'), 'delete');

      DesignFacade.create('sticker', _.extend(this.item, bboxData));
    }
  }
});
